import React from 'react';
import classnames from 'classnames';
// import { Link } from 'gatsby';

import Inner from './components/Inner';
import Lead from './components/Lead';

import * as styles from './hero.module.scss';

const Hero = ({ data, tags, postType, pageUrl, lang }) => {
  return (
    <section className={classnames(styles.section)}>
      <div className="scr-wrap">
        <div className={classnames(styles.inner)}>
          {postType === 'templateInnerPost' ? (
            // TODO: добавить import BackNavigate from 'components/BackNavigate'; когда будет контент
            <Inner tags={tags} data={data.templateInnerPost} />
          ) : (
            <Lead
              data={data.templateLeadGenerator}
              pageUrl={pageUrl}
              lang={lang}
            />
          )}
        </div>
      </div>
    </section>
  );
};

export default Hero;
